(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paiweisen-brand-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pws-brand-footer-flow')) {
    customElements.define('pws-brand-footer-flow', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.motion !== 'true') return;
        this.pauseButton = this.querySelector('.pwsf__motion-toggle');
        this.handlePause = () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          if (this.pauseButton) {
            this.pauseButton.setAttribute('aria-pressed', String(paused));
            this.pauseButton.textContent = paused ? this.pauseButton.dataset.resumeLabel : this.pauseButton.dataset.pauseLabel;
          }
        };
        if (this.pauseButton) this.pauseButton.addEventListener('click', this.handlePause);
        if (!('IntersectionObserver' in window)) {
          this.classList.add('pwsf--visible');
          return;
        }
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => this.classList.toggle('pwsf--visible', entry.isIntersecting));
        }, { threshold: 0 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.pauseButton && this.handlePause) this.pauseButton.removeEventListener('click', this.handlePause);
      }
    });
  }





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zuanshi"] && !Shopify.designMode) return;
  try {
    

  // One viewport canvas preserves particle continuity through all six sections.
  if (!customElements.get('zuanshi-snow')) {
    customElements.define('zuanshi-snow', class extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('canvas');
        this.ctx = this.canvas && this.canvas.getContext('2d');
        if (!this.ctx) return;
        this.root = this.closest('.zuanshi-wrapper');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce), (max-width: 749px)');
        this.abort = new AbortController();
        const options = { passive: true, signal: this.abort.signal };
        this.update = () => { if (this.motion.matches) { cancelAnimationFrame(this.frame); this.frame = null; this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height); return; } this.measure(); this.start(); };
        window.addEventListener('scroll', this.update, options);
        window.addEventListener('resize', this.update, options);
        document.addEventListener('visibilitychange', this.update, options);
        this.motion.addEventListener('change', this.update, options);
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.root);
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = null;
        if (this.abort) this.abort.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }
      measure() {
        const w = document.documentElement.clientWidth;
        const h = window.innerHeight;
        if (w !== this.w || h !== this.h) {
          this.w = w; this.h = h;
          const dpr = Math.min(window.devicePixelRatio || 1, 2);
          this.canvas.width = Math.round(w * dpr);
          this.canvas.height = Math.round(h * dpr);
          this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          const density = Math.max(50, Math.min(150, Number(this.dataset.density) || 100)) / 100;
          const scale = Math.min(1.35, Math.max(.55, w * h / 1100000)) * density;
          this.particles = [];
          // Dense far field / sparse middle / dense translucent foreground.
          [[64, .8, 1.5, 13, .48], [22, 1.8, 2.8, 26, .55], [48, 2.8, 4.6, 44, .30]].forEach((layer, depth) => {
            for (let i = 0; i < Math.round(layer[0] * scale); i++) {
              this.particles.push({ depth, x: Math.random() * w, y: Math.random() * h,
                r: layer[1] + Math.random() * (layer[2] - layer[1]),
                speed: layer[3] * (.8 + Math.random() * .4), alpha: layer[4],
                phase: Math.random() * Math.PI * 2 });
            }
          });
        }
        const box = this.root.getBoundingClientRect();
        this.top = Math.max(0, box.top);
        this.bottom = Math.min(h, box.bottom);
        this.left = Math.max(0, box.left);
        this.right = Math.min(w, box.right);
        this.active = this.bottom > this.top && this.right > this.left && !document.hidden && !this.motion.matches;
        this.style.clipPath = `inset(${this.top}px ${Math.max(0, w - this.right)}px ${Math.max(0, h - this.bottom)}px ${this.left}px)`;
        if (!this.active) {
          cancelAnimationFrame(this.frame);
          this.frame = null;
          this.ctx.clearRect(0, 0, w, h);
        }
      }
      start() {
        if (!this.active || this.frame) return;
        this.last = performance.now();
        this.frame = requestAnimationFrame(time => this.draw(time));
      }
      draw(time) {
        this.frame = null;
        if (!this.active || !this.isConnected) return;
        const dt = Math.min((time - this.last) / 1000, .05);
        this.last = time;
        const ctx = this.ctx;
        ctx.clearRect(0, 0, this.w, this.h);
        for (const p of this.particles) {
          p.y += p.speed * dt;
          p.x += (Math.sin(time / 2400 + p.phase) * (4 + p.depth * 3) + 3) * dt;
          if (p.y > this.h + 8) { p.y = -8; p.x = Math.random() * this.w; }
          if (p.x > this.w + 8) p.x = -8;
          if (p.x < -8) p.x = this.w + 8;
          ctx.globalAlpha = p.alpha;
          ctx.fillStyle = '#ffffff';
          // A fine cool edge keeps snow legible on the cream sections.
          ctx.strokeStyle = 'rgba(111,139,147,.42)';
          ctx.lineWidth = .65;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fill(); ctx.stroke();
        }
        ctx.globalAlpha = 1;
        this.frame = requestAnimationFrame(next => this.draw(next));
      }
    });
  }

  // Delegation also supports Shopify theme-editor section reloads.
  // Prefer this page's preceding product form without changing the selected variant.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('[data-zuanshi-product-cta]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var root = link.closest('.zuanshi-wrapper');
    var main = root.closest('main') || document;
    var forms = Array.from(main.querySelectorAll('form[action*="/cart/add"]'));
    var candidates = forms.filter(function (form) {
      return !root.contains(form) &&
        Boolean(form.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING) &&
        form.getClientRects().length > 0 &&
        form.querySelector('[name="id"]');
    });
    var form = candidates[candidates.length - 1];
    if (!form) return; // Keep the real href as the non-JS/no-form fallback.
    event.preventDefault();
    var productSection = form.closest('.shopify-section') || form;
    var focusTarget = productSection.querySelector('select[name="id"], input[type="radio"]:checked, button[type="submit"]:not([disabled])');
    productSection.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();
})();
